// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fade-enter-active[data-v-0c16dbca],.fade-leave-active[data-v-0c16dbca]{transition:opacity .3s}.fade-enter[data-v-0c16dbca],.fade-leave-to[data-v-0c16dbca]{opacity:0}.layout__row[data-v-0c16dbca]{align-items:center;display:flex;justify-content:center;min-height:100vh!important;padding:0 30px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
